import { storeState } from "@Store";
import { logoutRequest } from "@Store/App/actions";
import { LogoutOutlined } from "@ant-design/icons";
import { useAppDispatch } from "@hooks";
import { Tooltip } from "antd";
import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

function LogoutAction() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleLogout: MouseEventHandler<HTMLSpanElement> = (): void => {
    dispatch(logoutRequest());

    if (storeState.app.logout.success) {
      window.location.reload();
    }
  };

  return (
    <Tooltip key="signout" title={t("sidebar.logout")} placement="bottom">
      <span onClick={handleLogout}>
        <LogoutOutlined />
      </span>
    </Tooltip>
  );
}

export default LogoutAction;
